/**
 * FAQ block — close sibling accordion items when one is opened.
 * Uses the native <details> toggle event; no animation library needed.
 */
document.querySelectorAll('.wp-block-pulp-faq').forEach((block) => {
    const items = Array.from(block.querySelectorAll('.faq-item'));

    items.forEach((item) => {
        item.addEventListener('toggle', () => {
            if (! item.open) {
                return;
            }
            items.forEach((sibling) => {
                if (sibling !== item && sibling.open) {
                    sibling.open = false;
                }
            });
        });
    });
});
